"use client";

import { c as _c } from "react/compiler-runtime";
import { type AbilityScopePathDto, useHierarchiesControllerGetAncestors } from "@dc/gateway-jsonapi";
import { useAbility } from "@/hooks/useAbility";
import { useMe } from "@/hooks/useMe";
const TASK_READ_ACTIONS = new Set(["read", "manage"]);
function grantCoversTeam(rule: AbilityScopePathDto, teamPath: string): boolean {
  if (rule.inverted || rule.navOnly) return false;
  if (rule.subject !== "TASK" || !TASK_READ_ACTIONS.has(rule.action)) return false;
  const grantAtOrBelowTeam = rule.scopePath === teamPath || rule.scopePath.startsWith(`${teamPath}/`);
  const grantAboveTeamCoversIt = rule.subtree && teamPath.startsWith(`${rule.scopePath}/`);
  return grantAtOrBelowTeam || grantAboveTeamCoversIt;
}
export function useTeamTaskNavAccess(teamScopeId) {
  const $ = _c(10);
  const {
    can
  } = useAbility();
  const {
    me: userProfile
  } = useMe();
  const pathRules = userProfile?.meta?.abilityScopePaths;
  let t0;
  if ($[0] !== can) {
    t0 = can("read", {
      scopeType: "TASK"
    });
    $[0] = can;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const hasAnyTaskRead = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      scopeType: "TEAM",
      includeSelf: true
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = !!teamScopeId && hasAnyTaskRead && !!pathRules?.length;
  let t3;
  if ($[3] !== t2) {
    t3 = {
      query: {
        enabled: t2
      }
    };
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    data: teamNodeData,
    isError
  } = useHierarchiesControllerGetAncestors(teamScopeId ?? "", t1, t3);
  if (!teamScopeId || !hasAnyTaskRead) {
    return false;
  }
  if (!pathRules?.length) {
    return true;
  }
  if (isError) {
    return true;
  }
  let t4;
  let t5;
  if ($[5] !== pathRules || $[6] !== teamNodeData?.data || $[7] !== teamScopeId) {
    t5 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const teamPath = teamNodeData?.data?.find(node => node.id === teamScopeId)?.attributes?.path;
      if (!teamPath) {
        t5 = false;
        break bb0;
      }
      t4 = pathRules.some(rule => grantCoversTeam(rule, teamPath));
    }
    $[5] = pathRules;
    $[6] = teamNodeData?.data;
    $[7] = teamScopeId;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  if (t5 !== Symbol.for("react.early_return_sentinel")) {
    return t5;
  }
  return t4;
}